mutation Inertia_UpdateCompany($companyId: ID!, $name: String!) {
  updateCompany(input: { companyId: $companyId, name: $name }) {
    company {
      id
      name
    }
    errors
  }
}